<template>
    <!-- Marks Promo's own chrome for the platform e2e suite; App.vue drops it when embedded. -->
    <v-footer data-rtls-product-chrome app height="40px" elevation="3" class="footer">
        <v-btn
            text
            class="nav-link pa-0 mr-6 cookie-manager-btn text-none"
            color="white"
            :href="termsOfUse"
        >
            <v-col class="subheading">{{ $t('footer.termsOfUse') }}</v-col>
        </v-btn>
        <v-btn
            text
            class="nav-link pa-0 mr-6 cookie-manager-btn text-none"
            color="white"
            :href="privacyNote"
        >
            <v-col class="subheading">{{ $t('footer.privacyNote') }}</v-col>
        </v-btn>
        <template v-if="isManageCookiesButtonVisible">
            <v-btn
                text
                class="nav-link pa-0 mr-6 cookie-manager-btn text-none"
                color="white"
                :href="cookieNotice"
            >
                <v-col class="subheading">{{ $t('footer.cookieNotice') }}</v-col>
            </v-btn>
            <v-btn
                text
                class="nav-link pa-0 mr-6 cookie-manager-btn text-none"
                color="white"
                @click="onManageCookiesClick"
            >
                <v-col class="subheading">{{ $t('footer.manageCookiesButtonTitle') }}</v-col>
            </v-btn>
        </template>
        <v-col class="subheading">
            {{ copyrightOwText }}
        </v-col>
        <v-spacer />
        <v-btn text class="text-none ml-5" :href="link">
            <v-col class="subheading">{{ $t('footer.solutionFrom') }}:</v-col>
            <v-col offset-md1 xs12 class="ow-logo">
                <img :src="logo" height="12px" width="103px" />
            </v-col>
        </v-btn>
    </v-footer>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';
import { get } from 'lodash';
import { useStore } from 'vuex';
import logo from '../../img/logo-oliver-wyman-white.svg';

const link = 'https://labs.oliverwyman.com/index.html';
const termsOfUse =
    'https://www.oliverwyman.com/content/dam/oliver-wyman/v2/legal/OW-General-Web-Portal-ToU.pdf';
const privacyNote = 'https://www.oliverwyman.com/policies/privacy-notice-platforms.html';
const cookieNotice = 'https://www.oliverwyman.com/policies/cookie-notice.html';

const store = useStore();

const isManageCookiesButtonVisible = computed(() =>
    get(store.state.clientConfig.generalConfig, 'showCookieBanner', false)
);
const copyrightOwText = computed(() => `Copyright © ${moment().format('YYYY')} Oliver Wyman`);

const onManageCookiesClick = () => {
    // eslint-disable-next-line no-undef
    Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
.v-footer {
    &.footer {
        background-color: $promo-black;
        z-index: $main-footer-z-index;
        color: $promo-white;
        text-decoration-color: $promo-white;
        padding-left: 0.4rem;
        padding-right: 0rem;
    }

    .footer-link:hover:before {
        opacity: 0;
    }

    .cookie-manager-btn {
        text-decoration: underline;
    }

    .v-btn {
        text-decoration-color: #fff !important;
        margin-right: 0 !important;
        background: none !important;
    }
}

.subheading {
    font-size: 1.25rem;
    color: $promo-white;
    text-decoration-color: $promo-white;
    background: #000;
    max-height: 4rem;
}

.ow-logo {
    padding-top: 1.7rem;
}
</style>
